import React from "react";
import { Component } from "react";
import algoliasearch from "algoliasearch/lite";
import {
  InstantSearch,
  Configure,
  connectSortBy,
} from "react-instantsearch-dom";
import SearchResults from "../SearchResults/SearchResults";
import SortBy from "../SortBy/SortBy";
import NoOfProducts from "../NoOfProducts/NoOfProducts";
import PageHeader from "../PageHeader/PageHeader";

import "./SearchPoc.scss";
import FiltersModule from "../FiltersModule/FiltersModule";

const searchClient = algoliasearch(
  "K535CAAWVE",
  "8a831febe0110932cfa06ff0e2024b4f"
);

const SortByAlgolia = connectSortBy(SortBy);




const transformAPIcolours = (colours) => {

  // Merge multi and various
  colours = colours.filter(col => col !== "Multi" && col !== "Various");
  colours.push(["Multi", "Various"]);
  
  return colours;
}

const transformAPIsizes = (sizes) => {
  return sizes;
}
const transformAPIbrands = (brands) => {
  return brands;
}

class SearchPoc extends Component {
  constructor(props) {
    super(props);

    this.state = {
      colours: [],
      sizes: [],
      brands: [],
      filter: null,
      filtersReset: false,
    };
  }

  componentDidMount() {
    const storeRoot = document.getElementById("pen-stand-root");
    const filter =  (storeRoot && storeRoot.getAttribute("data-filter")) || "up1Category:Pens";

    const index = searchClient.initIndex("prod-product-wc-bestmatch");
    index.search(
      {
        query: "",
        filters: filter,
        facets: ["colour", "brand", "sizeDescription"],
        hitsPerPage: 1,
      },
      (err, { hits, facets } = {}) => {
        if (err) throw err;

        this.setState({
          brands: transformAPIbrands(Object.keys(facets.brand)),
          colours: transformAPIcolours(Object.keys(facets.colour)), 
          sizes: transformAPIsizes(Object.keys(facets.sizeDescription))
        });

      }
    );

    const pageProps = {
      pageTitle: storeRoot && storeRoot.getAttribute("data-title"),
      pageDescription: storeRoot && storeRoot.getAttribute("data-description"),
    };
    this.setState({ ...pageProps, filter });
  }

  resetFilters(reset) {
    this.setState({ filtersReset: reset });
  }

  render() {
    return (
      <React.Fragment>
        <PageHeader title={this.state.pageTitle} description={this.state.pageDescription} />
        <div className="container-fluid">
          <InstantSearch
            indexName="prod-product-wc-bestmatch"
            searchClient={searchClient}
          >
            <Configure filters={this.state.filter} />
            
            <FiltersModule
              brands={this.state.brands}
              colours={this.state.colours}
              sizes={this.state.sizes}
              resetFilters={(reset) => this.resetFilters(reset)}
              filtersReset={this.state.filtersReset}
            />

            <div className="results-header">
              <NoOfProducts />
              <SortByAlgolia
                defaultRefinement="prod-product-wc-bestmatch"
                items={[
                  { value: "prod-product-wc-bestmatch", label: "Best Match" },
                  { value: "prod-product-wc-newest", label: "Newest" },
                  { value: "prod-product-wc-name", label: "Name" },
                  { value: "prod-product-wc-price-asc", label: "Price Low to High" },
                  { value: "prod-product-wc-price-desc", label: "Price High to Low" },
                ]}
              />
            </div>
            <SearchResults />
          </InstantSearch>
        </div>
      </React.Fragment>
    );
  }
}

export default SearchPoc;
